export const changeCoffeeTypeReducer = (state = '', action) => {
    switch (action.type) {
      case "CHANGE_COFFEE_TYPE":
        return action.payload.coffeeType;
      default:
        return state;
    }
  };
  